import { Distance } from '../../../../../FrontendBundle/Resources/js/ofcs';
import MoveItemsCommand from '../command/moveItemsCommand';
import DrillItem from '../item/drillItem';
import TopField from './topField';

/**
 * @class CenterTopField
 */
export default class CenterTopField extends TopField {
    type = 'centerTop';
    supports = 'supportsPositioning';

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.getParentItem().get('height') - item.get('position').y);
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = item.getParentItem().get('height') - this.getValue();
        const difference = value - item.get('position').y;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'top', value);

        if (difference) {
            const command = new MoveItemsCommand(
                item,
                new Distance(0, difference),
            );

            this.commandExecutor.execute(command);
            this.updateValue(item);
            history.addCommand(command);
        }
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        const command = new MoveItemsCommand(
            item,
            new Distance(0, difference),
        );

        this.assertItemValue(item, 'top', item.get('position').y + difference);

        this.commandExecutor.execute(command);
        this.updateValue(item);
        history.addCommand(command);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof DrillItem;
    }
}
